module.exports = __webpack_public_path__ + "static/media/connections.8380ed95.svg";